export const SCROLL_DIRECTION = {
  UP: 'up',
  DOWN: 'down',
};
